/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=92c952f6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=92c952f6&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=92c952f6&lang=scss"

import exportComponent from "../../../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c952f6"]])

export default __exports__